import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  foodList: localStorage.getItem("foodList")
    ? JSON.parse(localStorage.getItem("foodList"))
    : [],
};

const foodListSlice = createSlice({
  name: "foodList",
  initialState,
  reducers: {
    setFoodList: (state, action) => {
      state.foodList = action.payload;
      localStorage.setItem("foodList", JSON.stringify(action.payload));
    },
    removeFoodList: (state, action) => {
      //state.users = [];
      state.foodList = [];
      localStorage.removeItem("foodList");
    },
  },
});

export const { setFoodList, removeFoodList } = foodListSlice.actions;

export default foodListSlice.reducer;
